import React from "react";
import styled from "styled-components";
import { scrollToElement } from "../helpers";
import Button, { LinkAsButton } from "./common/Button";
import { Paragraph } from "./JobApplySection";
import { isInternshipApplicantGroup } from "./utils";

const StyledButton = styled(Button)`
  max-width: 100%;
`;

export const INTERNSHIP_DESCRIPTION =
  "PGA Golf Management University Students: contact your Internship Coordinator if interested in this position.";

const ShowApplyButton = ({
  facilityUrl,
  data,
  isValidDeadline,
  isValidPostingStage,
}) =>
  facilityUrl ? (
    <LinkAsButton
      disabled={!isValidPostingStage}
      href={facilityUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      APPLY
    </LinkAsButton>
  ) : isInternshipApplicantGroup(data) ? (
    <Paragraph className="mt-3">{INTERNSHIP_DESCRIPTION}</Paragraph>
  ) : (
    <StyledButton
      disabled={!isValidDeadline || !isValidPostingStage}
      onClick={() => scrollToElement("application-form")}
    >
      APPLY
    </StyledButton>
  );

export default ShowApplyButton;
